import React from "react";
import Header from './../organisms/Header';
import ContentProyects from './../Templates/ContentProyects';
import Footer from "./../organisms/Footer";

const Proyects = () => {
    return (
        <div className="Proyects">
            <Header />
            <ContentProyects />
            <Footer />

        </div>
    );
}

export default Proyects;